import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import { insuredOffers } from 'assets/img/index'
import { TextLinkImage } from 'components/molecules'
import { arrayOf, shape, string } from 'prop-types'

const InsuredOffers = ({ offers }) => {
  const textContext = useContext(TextContext)
  const { CARENETWORK, CAREHOME_PLUS, FALLING_PREV, TEAMWERK } = insuredOffers

  const getImage = (type) => {
    switch (type) {
      case 'CARENETWORK':
        return CARENETWORK
      case 'CAREHOME_PLUS':
        return CAREHOME_PLUS
      case 'FALLING_PREV':
        return FALLING_PREV
      case 'TEAMWERK':
        return TEAMWERK
      default:
        return ''
    }
  }

  return (
    <>
      {offers.length > 0 &&
        offers.map((offer, idx) => (
          <div data-cy-insured-offer={ offer.type } key={ idx }>
            <TextLinkImage
              key={ idx }
              headline={ offer.headline }
              copy={ offer.copy }
              image={{
                url: getImage(offer.type),
                alt: textContext[`${ offer.type }.logo.title`] || '',
              }}
              moreLink={{
                url: offer.moreLink,
                target: '_blank',
              }}
            />
          </div>
        ))}
    </>
  )
}

InsuredOffers.propTypes = {
  offers: arrayOf(
    shape({
      type: string.isRequired,
      headline: string.isRequired,
      copy: string.isRequired,
      moreLink: string,
    })
  ).isRequired,
}

export default InsuredOffers
